export enum DepartmentType {
    SMAM = 1,
    GreaterChennaiCorporation = 2,
    HorticultureDepartment = 3,
    PublicWorksDepartment = 4,
    HealthMedicalDepartment = 5,
    ForestDepartment = 6,
    AgricultureDepartment = 7,
    MarketingDepartment = 8,
    AnimalHusbandryDepartment = 9,
    RuralDepartment = 10,
    CorporationDepartment = 11,
    Municipality = 12,
    Townpanchayat = 13,
    OtherGovernmentDepartment = 14,
    PaccsDepartment = 16
}
